webpackJsonp([10],{

/***/ 1015:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1016);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("7ac65f61", content, true, {});

/***/ }),

/***/ 1016:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".detail-row td[data-v-aec8a6e4]{height:55px}", "", {"version":3,"sources":["/app/src/components/master/sellingTariff/Surcharge.vue"],"names":[],"mappings":"AACA,gCACE,WAAa,CACd","file":"Surcharge.vue","sourcesContent":["\n.detail-row td[data-v-aec8a6e4] {\n  height: 55px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1017:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralSurcharge_vue__ = __webpack_require__(779);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e10f610_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralSurcharge_vue__ = __webpack_require__(1021);
function injectStyle (ssrContext) {
  __webpack_require__(1018)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralSurcharge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e10f610_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralSurcharge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1019);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("f7eab986", content, true, {});

/***/ }),

/***/ 1019:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".header-picker{display:none!important}", "", {"version":3,"sources":["/app/src/components/master/sellingTariff/GeneralSurcharge.vue"],"names":[],"mappings":"AACA,eACE,sBAAyB,CAC1B","file":"GeneralSurcharge.vue","sourcesContent":["\n.header-picker {\n  display: none !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1020:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/master/selling/GeneralSurcharges";

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(masterClassId, type, serviceType) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var dynamicURL;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dynamicURL = serviceType === 1 ? "airport-transfer" : "rental";
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/" + dynamicURL + "/" + masterClassId + "?type=" + type)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  create: function create(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  update: function update(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  delete: function _delete(id) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ("/" + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 1021:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedMasterClass && _vm.isOpen)?_c('div',[_c('div',{ref:"vuemodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-sell",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("\n                General Surcharge ("+_vm._s(_vm.selectedMasterClass.masterClassName)+")\n              ")]),_vm._v(" "),(_vm.timestampItem)?_c('h6',[_vm._v("Last Updated: "+_vm._s(_vm.timestampItem))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.onCloseModal()}}},[_c('i',{staticClass:"ic-close"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper modal-detail"},[_c('div',{staticClass:"modal-content-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"col-sm-4 divider-right pr-25"},[(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                      This form has errors\n                    ")]):_vm._e(),_vm._v(" "),(_vm.serviceType === 1)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Zones")]),_vm._v(" "),_c('multiselect',{class:{
                          'field-error':
                            _vm.isSubmitted && !_vm.$v.model.zones.required,
                        },attrs:{"options":_vm.zones,"multiple":true,"close-on-select":false,"placeholder":"Select zones","label":"label","track-by":"id"},model:{value:(_vm.model.zones),callback:function ($$v) {_vm.$set(_vm.model, "zones", $$v)},expression:"model.zones"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.zones.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                        Zone(s) is required\n                      ")]):_vm._e()],1):_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Group Zone")]),_vm._v(" "),_c('multiselect',{class:{
                          'field-error':
                            _vm.isSubmitted && !_vm.$v.model.groupZones.required,
                        },attrs:{"options":_vm.groupZones,"multiple":true,"close-on-select":false,"placeholder":"Select group zones","label":"label","track-by":"id"},model:{value:(_vm.model.groupZones),callback:function ($$v) {_vm.$set(_vm.model, "groupZones", $$v)},expression:"model.groupZones"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.groupZones.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                        Group zone is required\n                      ")]):_vm._e()],1),_vm._v(" "),_c('ul',{staticClass:"nav nav-tabs nav-justified tabs-mini-form"},[_c('li',{class:[
                          _vm.activeTab === _vm.generalSurchargeType.NightTime
                            ? 'active'
                            : '' ],on:{"click":function($event){return _vm.onChangeActiveTab(_vm.generalSurchargeType.NightTime)}}},[_c('a',{attrs:{"href":"#night-surcharge","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'nighttime'}}},[_vm._v("\n                          Morning/Night/Peak-Hour\n                        ")])]),_vm._v(" "),_c('li',{class:[
                          _vm.activeTab === _vm.generalSurchargeType.Weekend
                            ? 'active'
                            : '' ],on:{"click":function($event){return _vm.onChangeActiveTab(_vm.generalSurchargeType.Weekend)}}},[_c('a',{attrs:{"href":"#weekend-surcharge","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'weekend'}}},[_vm._v("\n                          Weekend\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content pt-10"},[_c('div',{staticClass:"tab-pane fade",class:[
                          _vm.activeTab === _vm.generalSurchargeType.NightTime
                            ? 'in active'
                            : '' ],attrs:{"id":"night-surcharge"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Start Time")]),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"nightTimeSurchargeStart","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","label":"Select time","only-time":"","no-label":"","no-button":""},model:{value:(_vm.model.nightTimeSurchargeStart),callback:function ($$v) {_vm.$set(_vm.model, "nightTimeSurchargeStart", $$v)},expression:"model.nightTimeSurchargeStart"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("End Time")]),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"nightTimeSurchargeEnd","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","label":"Select time","only-time":"","no-label":"","no-button":""},model:{value:(_vm.model.nightTimeSurchargeEnd),callback:function ($$v) {_vm.$set(_vm.model, "nightTimeSurchargeEnd", $$v)},expression:"model.nightTimeSurchargeEnd"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Rate Type")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Select rate type","label":"text","options":_vm.amountTypes,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.model.rateAmountType),callback:function ($$v) {_vm.$set(_vm.model, "rateAmountType", $$v)},expression:"model.rateAmountType"}})],1),_vm._v(" "),(_vm.showCurrencyField)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Currency")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                              'field-error':
                                _vm.isSubmitted && !_vm.$v.model.currency.required,
                            },attrs:{"placeholder":"Select currency","label":"text","options":_vm.currencies,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.model.currency),callback:function ($$v) {_vm.$set(_vm.model, "currency", $$v)},expression:"model.currency"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.currency.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                            Currency is required\n                          ")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Rate")]),_vm._v(" "),(
                              _vm.model.rateAmountType === 0 ||
                              _vm.model.rateAmountType === 1
                            )?_c('currency-input',{staticClass:"form-control",attrs:{"name":"flatRateAmountFlat","autocomplete":"off","placeholder":"Enter rate","allow-negative":false,"currency":null,"locale":_vm.moneyFormat.cultureCode,"precision":_vm.moneyFormat.numberOfDecimal},model:{value:(_vm.model.flatRateAmount),callback:function ($$v) {_vm.$set(_vm.model, "flatRateAmount", $$v)},expression:"model.flatRateAmount"}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.flatRateAmount),expression:"model.flatRateAmount"}],staticClass:"form-control",attrs:{"type":"number","name":"flatRateAmountPercentage","placeholder":"Enter rate","min":"0","step":"any"},domProps:{"value":(_vm.model.flatRateAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "flatRateAmount", $event.target.value)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[
                          _vm.activeTab === _vm.generalSurchargeType.Weekend
                            ? 'in active'
                            : '' ],attrs:{"id":"weekend-surcharge"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Rate Type")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Select rate type","label":"text","options":_vm.amountTypes,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.model.rateAmountType),callback:function ($$v) {_vm.$set(_vm.model, "rateAmountType", $$v)},expression:"model.rateAmountType"}})],1),_vm._v(" "),(_vm.showCurrencyField)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Currency")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                              'field-error':
                                _vm.isSubmitted && !_vm.$v.model.currency.required,
                            },attrs:{"placeholder":"Select currency","label":"text","options":_vm.currencies,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.model.currency),callback:function ($$v) {_vm.$set(_vm.model, "currency", $$v)},expression:"model.currency"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.currency.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                            Currency is required\n                          ")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Rate")]),_vm._v(" "),(
                              _vm.model.rateAmountType === 0 ||
                              _vm.model.rateAmountType === 1
                            )?_c('currency-input',{staticClass:"form-control",attrs:{"name":"flatRateAmountFlat","autocomplete":"off","placeholder":"Enter rate","allow-negative":false,"currency":null,"locale":_vm.moneyFormat.cultureCode,"precision":_vm.moneyFormat.numberOfDecimal},model:{value:(_vm.model.flatRateAmount),callback:function ($$v) {_vm.$set(_vm.model, "flatRateAmount", $$v)},expression:"model.flatRateAmount"}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.flatRateAmount),expression:"model.flatRateAmount"}],staticClass:"form-control",attrs:{"type":"number","name":"flatRateAmountPercentage","placeholder":"Enter rate","min":"0","step":"any"},domProps:{"value":(_vm.model.flatRateAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "flatRateAmount", $event.target.value)}}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Days")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.weekends,"multiple":true,"close-on-select":false,"placeholder":"Select day","label":"","track-by":""},model:{value:(_vm.model.weekendSurchargeDays),callback:function ($$v) {_vm.$set(_vm.model, "weekendSurchargeDays", $$v)},expression:"model.weekendSurchargeDays"}})],1)])]),_vm._v(" "),(_vm.isAllowToCreate || _vm.isAllowToUpdate)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onResetForm()}}},[_vm._v("\n                        Reset\n                      ")]),_vm._v(" "),(!_vm.isUpdate && _vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onSubmitForm()}}},[_vm._v("\n                        Create\n                      ")]):_vm._e(),_vm._v(" "),(_vm.isUpdate && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onSubmitForm()}}},[_vm._v("\n                        Update\n                      ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pl-20"},[_c('div',{staticClass:"table-modal-detail"},[(_vm.activeTab)?_c('div',{staticClass:"table-responsive table-accordion"},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',{staticClass:"number"},[_vm._v("No")]),_vm._v(" "),_c('th',[_vm._v("Zones")]),_vm._v(" "),(
                                  _vm.activeTab === _vm.generalSurchargeType.NightTime
                                )?[_c('th',{staticClass:"text-center"},[_vm._v("Start Time")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("End Time")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Rate Type")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Rate")])]:_vm._e(),_vm._v(" "),(
                                  _vm.activeTab === _vm.generalSurchargeType.Weekend
                                )?[_c('th',{staticClass:"text-center"},[_vm._v("Rate Type")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Rate")]),_vm._v(" "),_c('th',[_vm._v("Days")])]:_vm._e(),_vm._v(" "),(
                                  _vm.activeTab ===
                                  _vm.generalSurchargeType.GarageTime
                                )?[_c('th',{staticClass:"text-center"},[_vm._v("Rate")]),_vm._v(" "),_c('th',[_vm._v("Duration Band")]),_vm._v(" "),_c('th',[_vm._v("Minimum Band")])]:_vm._e(),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"120px"}},[_vm._v("\n                                Status\n                              ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"100px"}},[_vm._v("\n                                Action\n                              ")])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.surcharges),function(item,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-center pl-10 pr-10"},[_vm._v("\n                                "+_vm._s(index + 1)+"\n                              ")]),_vm._v(" "),_c('td',{staticClass:"pl-10 pr-10"},[(
                                    item.zones &&
                                    item.zones.length > 0 &&
                                    _vm.serviceType === 1
                                  )?_vm._l((item.zones),function(zoneItem,idxZone){return _c('p',{key:idxZone,staticClass:"mb-0"},[_vm._v("\n                                    "+_vm._s(((zoneItem.group) + " - " + (zoneItem.name)))+"\n                                  ")])}):(
                                    item.zoneGroups &&
                                    item.zoneGroups.length > 0 &&
                                    _vm.serviceType === 2
                                  )?_vm._l((item.zoneGroups),function(zoneItem,idxZone){return _c('p',{key:idxZone,staticClass:"mb-0"},[_vm._v("\n                                    "+_vm._s(zoneItem.name)+"\n                                  ")])}):[_vm._v(" - ")]],2),_vm._v(" "),(
                                  _vm.activeTab === _vm.generalSurchargeType.NightTime
                                )?[_c('td',{staticClass:"text-center pl-10 pr-10"},[_vm._v("\n                                  "+_vm._s(item.nightTimeSurchargeStart)+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"text-center pl-10 pr-10"},[_vm._v("\n                                  "+_vm._s(item.nightTimeSurchargeEnd)+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"text-center pl-10 pr-10"},[_vm._v("\n                                  "+_vm._s(item.amountTypeDescription)+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"text-right pl-10 pr-10"},[_vm._v("\n                                  "+_vm._s(_vm.renderRateIntoTable(
                                      item.amountType,
                                      item.flatRateAmount,
                                      item.currency
                                    ))+"\n                                ")])]:_vm._e(),_vm._v(" "),(
                                  _vm.activeTab === _vm.generalSurchargeType.Weekend
                                )?[_c('td',{staticClass:"text-center pl-10 pr-10"},[_vm._v("\n                                  "+_vm._s(item.amountTypeDescription)+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"text-right pl-10 pr-10"},[_vm._v("\n                                  "+_vm._s(_vm.renderRateIntoTable(
                                      item.amountType,
                                      item.flatRateAmount,
                                      item.currency
                                    ))+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"pl-10 pr-10"},[_vm._v("\n                                  "+_vm._s(_vm.renderDaysIntoTable(
                                      item.weekendSurchargeDays
                                    ))+"\n                                ")])]:_vm._e(),_vm._v(" "),(
                                  _vm.activeTab ===
                                  _vm.generalSurchargeType.GarageTime
                                )?[_c('td',{staticClass:"pl-10 pr-10"},[_vm._v("\n                                  "+_vm._s(item.currency)+"\n                                  "+_vm._s(_vm.printMoney(item.flatRateAmount))+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"pl-10 pr-10"},[_vm._v("\n                                  "+_vm._s(item.garageTimeBandMinutes)+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"pl-10 pr-10"},[_vm._v("\n                                  "+_vm._s(item.garageTimeBandMinimum)+"\n                                ")])]:_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":!_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.onChangeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                    "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                                  ")])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.onEdit(item)}}},[_c('span',[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.onDelete(item)}}},[_c('i',{staticClass:"ic-close"})]):_vm._e()])])],2)}),0)])]):_vm._e()])])])])])])])])])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.submitDelete,"cancel":_vm.cancelDelete}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1022:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CancellationSurcharge_vue__ = __webpack_require__(780);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3354bbe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CancellationSurcharge_vue__ = __webpack_require__(1024);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CancellationSurcharge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3354bbe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CancellationSurcharge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1023:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/selling/CancellationSurcharges';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(masterClassId, serviceType) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var dynamicURL;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dynamicURL = serviceType === 1 ? 'airport-transfer' : 'rental';
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/' + dynamicURL + '/' + masterClassId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 3:
              return _context.abrupt('return', _context.sent);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  create: function create(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  update: function update(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  delete: function _delete(id) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 1024:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedMasterClass && _vm.isOpen)?_c('div',[_c('div',{ref:"vuemodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-sell",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("\n                Cancellation Policy ("+_vm._s(_vm.selectedMasterClass.masterClassName)+")\n              ")]),_vm._v(" "),(_vm.timestampItem)?_c('h6',[_vm._v("Last Updated: "+_vm._s(_vm.timestampItem))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.onCloseModal()}}},[_c('i',{staticClass:"ic-close"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper modal-detail"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{class:_vm.serviceType === 1
                          ? 'col-sm-3 divider-right pr-25'
                          : 'col-sm-4 divider-right pr-25'},[(_vm.serviceType === 1)?[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Range of Hour (start)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.startHourBeforePickup),expression:"model.startHourBeforePickup"}],staticClass:"form-control",class:{
                              'field-error':
                                _vm.isSubmitted &&
                                _vm.$v.model.startHourBeforePickup.$error,
                            },attrs:{"type":"number"},domProps:{"value":(_vm.model.startHourBeforePickup)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "startHourBeforePickup", $event.target.value)}}}),_vm._v(" "),(
                              _vm.isSubmitted &&
                              _vm.$v.model.startHourBeforePickup.$error
                            )?_c('div',[(!_vm.$v.model.startHourBeforePickup.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                              Range start is required\n                            ")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.startHourBeforePickup.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                              Min hour is\n                              "+_vm._s(_vm.$v.model.startHourBeforePickup.$params
                                  .minValue.min)+"\n                            ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Range of Hour (end)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.endHourBeforePickup),expression:"model.endHourBeforePickup"}],staticClass:"form-control",class:{
                              'field-error':
                                _vm.isSubmitted &&
                                _vm.$v.model.endHourBeforePickup.$error,
                            },attrs:{"type":"number","disabled":_vm.model.endHourBeforePickupIsInfinite},domProps:{"value":(_vm.model.endHourBeforePickup)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "endHourBeforePickup", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.endHourBeforePickupIsInfinite),expression:"model.endHourBeforePickupIsInfinite"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.endHourBeforePickupIsInfinite)?_vm._i(_vm.model.endHourBeforePickupIsInfinite,null)>-1:(_vm.model.endHourBeforePickupIsInfinite)},on:{"change":[function($event){var $$a=_vm.model.endHourBeforePickupIsInfinite,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model, "endHourBeforePickupIsInfinite", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model, "endHourBeforePickupIsInfinite", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model, "endHourBeforePickupIsInfinite", $$c)}},function($event){return _vm.changeInfinite()}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                              Infinite\n                            ")])]),_vm._v(" "),(
                              _vm.isSubmitted &&
                              _vm.$v.model.endHourBeforePickup.$error
                            )?_c('div',[(!_vm.$v.model.endHourBeforePickup.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                              Range end is required\n                            ")]):_vm._e()]):_vm._e()])]:[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("If cancelled between")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.startHourBeforePickup),expression:"model.startHourBeforePickup"}],staticClass:"form-control",class:{
                                  'field-error':
                                    _vm.isSubmitted &&
                                    _vm.$v.model.startHourBeforePickup.$error,
                                },attrs:{"type":"number"},domProps:{"value":(_vm.model.startHourBeforePickup)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "startHourBeforePickup", $event.target.value)}}}),_vm._v(" "),_vm._m(0),_vm._v(" "),(
                                  _vm.isSubmitted &&
                                  _vm.$v.model.startHourBeforePickup.$error
                                )?_c('div',[(
                                    !_vm.$v.model.startHourBeforePickup.required
                                  )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                                  Range start is required\n                                ")]):_vm._e(),_vm._v(" "),(
                                    !_vm.$v.model.startHourBeforePickup.minValue
                                  )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                                  Min hour is\n                                  "+_vm._s(_vm.$v.model.startHourBeforePickup.$params
                                      .minValue.min)+"\n                                ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.endHourBeforePickup),expression:"model.endHourBeforePickup"}],staticClass:"form-control",class:{
                                  'field-error':
                                    _vm.isSubmitted &&
                                    _vm.$v.model.endHourBeforePickup.$error,
                                },attrs:{"type":"number","disabled":_vm.model.endHourBeforePickupIsInfinite},domProps:{"value":(_vm.model.endHourBeforePickup)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "endHourBeforePickup", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(
                                    _vm.model.endHourBeforePickupIsInfinite
                                  ),expression:"\n                                    model.endHourBeforePickupIsInfinite\n                                  "}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(
                                    _vm.model.endHourBeforePickupIsInfinite
                                  )?_vm._i(
                                    _vm.model.endHourBeforePickupIsInfinite
                                  ,null)>-1:(
                                    _vm.model.endHourBeforePickupIsInfinite
                                  )},on:{"change":[function($event){var $$a=
                                    _vm.model.endHourBeforePickupIsInfinite
                                  ,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model, "endHourBeforePickupIsInfinite", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model, "endHourBeforePickupIsInfinite", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model, "endHourBeforePickupIsInfinite", $$c)}},function($event){return _vm.changeInfinite()}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                  Infinite\n                                ")])]),_vm._v(" "),(
                                  _vm.isSubmitted &&
                                  _vm.$v.model.endHourBeforePickup.$error
                                )?_c('div',[(
                                    !_vm.$v.model.endHourBeforePickup.required
                                  )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                                  Range end is required\n                                ")]):_vm._e()]):_vm._e()])])])],_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.percentageCharge),expression:"model.percentageCharge"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.percentageCharge.$error,
                          },attrs:{"type":"number","step":"any"},domProps:{"value":(_vm.model.percentageCharge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "percentageCharge", $event.target.value)}}}),_vm._v(" "),(
                            _vm.isSubmitted && _vm.$v.model.percentageCharge.$error
                          )?_c('div',[(!_vm.$v.model.percentageCharge.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Rate is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.percentageCharge.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Min percentage is\n                            "+_vm._s(_vm.$v.model.percentageCharge.$params.minValue.min))]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.serviceType === 2)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Maximum No. of Hours Charged")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.maximumChargeHour),expression:"model.maximumChargeHour"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted &&
                              _vm.$v.model.maximumChargeHour.$error,
                          },attrs:{"type":"number","disabled":_vm.model.maximumChargeHourIsInfinite},domProps:{"value":(_vm.model.maximumChargeHour)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "maximumChargeHour", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.maximumChargeHourIsInfinite),expression:"model.maximumChargeHourIsInfinite"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.maximumChargeHourIsInfinite)?_vm._i(_vm.model.maximumChargeHourIsInfinite,null)>-1:(_vm.model.maximumChargeHourIsInfinite)},on:{"change":[function($event){var $$a=_vm.model.maximumChargeHourIsInfinite,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model, "maximumChargeHourIsInfinite", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model, "maximumChargeHourIsInfinite", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model, "maximumChargeHourIsInfinite", $$c)}},function($event){return _vm.changeMaxChargeHoursInInfinite()}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                            Full Booking Period\n                          ")])]),_vm._v(" "),(
                            _vm.isSubmitted && _vm.$v.model.maximumChargeHour.$error
                          )?_c('div',[(!_vm.$v.model.maximumChargeHour.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                            Range end is required\n                          ")]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isAllowToCreate || _vm.isAllowToUpdate)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onResetForm()}}},[_vm._v("\n                          Reset\n                        ")]),_vm._v(" "),(!_vm.isUpdate && _vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onSubmitForm()}}},[_vm._v("\n                          Create\n                        ")]):_vm._e(),_vm._v(" "),(_vm.isUpdate && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onSubmitForm()}}},[_vm._v("\n                          Update\n                        ")]):_vm._e()]):_vm._e()],2),_vm._v(" "),_c('div',{class:_vm.serviceType === 1
                          ? 'col-sm-9 divider-left pl-20'
                          : 'col-sm-8 divider-left pl-20'},[_c('div',{staticClass:"table-modal-detail"},[_c('div',{staticClass:"table-responsive table-accordion"},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',{staticClass:"number"},[_vm._v("No")]),_vm._v(" "),_c('th',[_vm._v("Range of Hour")]),_vm._v(" "),_c('th',{staticClass:"text-right",staticStyle:{"padding":"15px 0"}},[_vm._v("\n                                  Charge Amount per Hour (%)\n                                ")]),_vm._v(" "),(_vm.serviceType === 2)?_c('th',{staticClass:"text-center"},[_vm._v("\n                                  Maximum No. of Hours Charged\n                                ")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:item.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"15px 10px"}},[_vm._v("\n                                  "+_vm._s(_vm.$helper.printRangeOfHour(
                                      item.startHourBeforePickup,
                                      item.endHourBeforePickup
                                    ))+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                                  "+_vm._s(item.percentageCharge)+"\n                                ")]),_vm._v(" "),(_vm.serviceType === 2)?_c('td',{staticClass:"text-center"},[_vm._v("\n                                  "+_vm._s(item.maximumChargeHour === null
                                      ? "-"
                                      : item.maximumChargeHour < 0
                                      ? "Full of Booking Hour"
                                      : item.maximumChargeHour)+"\n                                ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":!_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.onChangeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                      "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                                    ")])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.onEdit(item)}}},[_c('span',[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.onDelete(item)}}},[_c('i',{staticClass:"ic-close"})]):_vm._e()])])])}),0)])])])])])])])])])])])])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.submitDelete,"cancel":_vm.cancelDelete}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"cursor-pointer"},[_c('span',{staticClass:"font-weight-normal v-align-middle"},[_vm._v("\n                                  Hours before pick-up time\n                                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"required"},[_vm._v("\n                          Charge Amount per Hour\n                          "),_c('span',{staticClass:"--grey50"},[_vm._v("(%)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1025:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeakPeriodSurcharge_vue__ = __webpack_require__(781);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7daf8b1b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeakPeriodSurcharge_vue__ = __webpack_require__(1027);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeakPeriodSurcharge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7daf8b1b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeakPeriodSurcharge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1026:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/selling/PeakPeriodSurcharges';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(masterClassId, serviceType) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var dynamicURL;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dynamicURL = serviceType === 1 ? 'airport-transfer' : 'rental';
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/' + dynamicURL + '/' + masterClassId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 3:
              return _context.abrupt('return', _context.sent);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  create: function create(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  update: function update(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  delete: function _delete(id) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 1027:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedMasterClass && _vm.isOpen)?_c('div',[_c('div',{ref:"vuemodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-sell",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Peak Period ("+_vm._s(_vm.selectedMasterClass.masterClassName)+")")]),_vm._v(" "),(_vm.timestampItem)?_c('h6',[_vm._v("Last Updated: "+_vm._s(_vm.timestampItem))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.onCloseModal()}}},[_c('i',{staticClass:"ic-close"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper modal-detail"},[_c('div',{staticClass:"modal-content-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"col-sm-3 divider-right pr-25"},[(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                      This form has errors\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Peak Period")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                          'field-error':
                            _vm.isSubmitted && _vm.$v.model.peakPeriodId.$error,
                        },attrs:{"label":"title","placeholder":"Select peak period","options":_vm.peakPeriods,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; }},model:{value:(_vm.model.peakPeriodId),callback:function ($$v) {_vm.$set(_vm.model, "peakPeriodId", $$v)},expression:"model.peakPeriodId"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.peakPeriodId.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                        Peak Period is required\n                      ")]):_vm._e()],1),_vm._v(" "),(_vm.serviceType === 1)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Zones")]),_vm._v(" "),_c('multiselect',{class:{
                          'field-error':
                            _vm.isSubmitted && !_vm.$v.model.zones.required,
                        },attrs:{"options":_vm.zones,"multiple":true,"close-on-select":false,"placeholder":"Select zones","label":"label","track-by":"id"},model:{value:(_vm.model.zones),callback:function ($$v) {_vm.$set(_vm.model, "zones", $$v)},expression:"model.zones"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.zones.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                        Zone(s) is required\n                      ")]):_vm._e()],1):_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Group Zone")]),_vm._v(" "),_c('multiselect',{class:{
                          'field-error':
                            _vm.isSubmitted && !_vm.$v.model.groupZones.required,
                        },attrs:{"options":_vm.groupZones,"multiple":true,"close-on-select":false,"placeholder":"Select group zones","label":"label","track-by":"id"},model:{value:(_vm.model.groupZones),callback:function ($$v) {_vm.$set(_vm.model, "groupZones", $$v)},expression:"model.groupZones"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.groupZones.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                        Group zone is required\n                      ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Rate Type")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Select rate type","label":"text","options":_vm.amountTypes,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.model.amountType),callback:function ($$v) {_vm.$set(_vm.model, "amountType", $$v)},expression:"model.amountType"}})],1),_vm._v(" "),(_vm.showCurrencyField)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Currency")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                          'field-error':
                            _vm.isSubmitted && !_vm.$v.model.currency.required,
                        },attrs:{"placeholder":"Select currency","label":"text","options":_vm.currencies,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.model.currency),callback:function ($$v) {_vm.$set(_vm.model, "currency", $$v)},expression:"model.currency"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.currency.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                        Currency is required\n                      ")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" Rate ")]),_vm._v(" "),(
                          _vm.model.amountType === 0 || _vm.model.amountType === 1
                        )?_c('currency-input',{staticClass:"form-control",class:{
                          'field-error':
                            _vm.isSubmitted && _vm.$v.model.flatRate.$error,
                        },attrs:{"autocomplete":"off","placeholder":"Enter rate","allow-negative":false,"currency":null,"locale":_vm.moneyFormat.cultureCode,"precision":_vm.moneyFormat.numberOfDecimal},model:{value:(_vm.model.flatRate),callback:function ($$v) {_vm.$set(_vm.model, "flatRate", $$v)},expression:"model.flatRate"}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.flatRate),expression:"model.flatRate"}],staticClass:"form-control",class:{
                          'field-error':
                            _vm.isSubmitted && _vm.$v.model.flatRate.$error,
                        },attrs:{"type":"number","name":"flatRateAmountPercentage","placeholder":"Enter rate","min":"0","step":"any"},domProps:{"value":(_vm.model.flatRate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "flatRate", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.flatRate.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                        Min flat rate is 0\n                      ")]):_vm._e()],1),_vm._v(" "),(_vm.isAllowToCreate || _vm.isAllowToUpdate)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onResetForm()}}},[_vm._v("\n                        Reset\n                      ")]),_vm._v(" "),(!_vm.isUpdate && _vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onSubmitForm()}}},[_vm._v("\n                        Create\n                      ")]):_vm._e(),_vm._v(" "),(_vm.isUpdate && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onSubmitForm()}}},[_vm._v("\n                        Update\n                      ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 pl-20"},[_c('div',{staticClass:"table-modal-detail"},[_c('div',{staticClass:"table-responsive table-accordion"},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',{staticClass:"number"},[_vm._v("No")]),_vm._v(" "),_c('th',[_vm._v("Peak Period")]),_vm._v(" "),_c('th',[_vm._v("\n                                "+_vm._s(_vm.serviceType === 1 ? "Zones" : "Group Zones")+"\n                              ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Rate Type")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Rate")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"120px"}},[_vm._v("\n                                Status\n                              ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"100px"}},[_vm._v("\n                                Action\n                              ")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:item.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.peakPeriod.title))]),_vm._v(" "),_c('td',[(
                                    item.zones &&
                                    item.zones.length > 0 &&
                                    _vm.serviceType === 1
                                  )?_vm._l((item.zones),function(zone,idxZoneItem){return _c('p',{key:idxZoneItem},[_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(zone.group))]),_vm._v("\n                                    "+_vm._s(zone.name)+"\n                                  ")])}):(
                                    item.zoneGroups &&
                                    item.zoneGroups.length > 0 &&
                                    _vm.serviceType === 2
                                  )?_vm._l((item.zoneGroups),function(zone,idxZoneItem){return _c('p',{key:idxZoneItem},[_vm._v("\n                                    "+_vm._s(zone.name)+"\n                                  ")])}):[_vm._v(" - ")]],2),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                                "+_vm._s(item.amountTypeDescription)+"\n                              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                                "+_vm._s(_vm.renderRateIntoTable(
                                    item.amountType,
                                    item.flatRate,
                                    item.currency
                                  ))+"\n                              ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":!_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.onChangeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                    "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                                  ")])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.onEdit(item)}}},[_c('span',[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.onDelete(item)}}},[_c('i',{staticClass:"ic-close"})]):_vm._e()])])])}),0)])])])])])])])])])])])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.submitDelete,"cancel":_vm.cancelDelete}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1028:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WaitingTimeSurcharge_vue__ = __webpack_require__(782);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51dfec1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WaitingTimeSurcharge_vue__ = __webpack_require__(1030);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WaitingTimeSurcharge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51dfec1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WaitingTimeSurcharge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1029:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/selling/WaitingTimeSurcharges';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(masterClassId) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/' + masterClassId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  create: function create(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  update: function update(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  delete: function _delete(id) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 1030:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedMasterClass && _vm.isOpen)?_c('div',[_c('div',{ref:"vuemodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-sell",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("\n                Waiting Time ("+_vm._s(_vm.selectedMasterClass.masterClassName)+")\n              ")]),_vm._v(" "),(_vm.timestampItem)?_c('h6',[_vm._v("Last Updated: "+_vm._s(_vm.timestampItem))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.onCloseModal()}}},[_c('i',{staticClass:"ic-close"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper modal-detail"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 divider-right pr-25"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Source Type")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.type.$error,
                          },attrs:{"label":"text","options":_vm.sourceTypes,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.model.type),callback:function ($$v) {_vm.$set(_vm.model, "type", $$v)},expression:"model.type"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.type.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                          Type is required\n                        ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Zones")]),_vm._v(" "),_c('multiselect',{class:{
                            'field-error':
                              _vm.isSubmitted && !_vm.$v.model.zones.required,
                          },attrs:{"options":_vm.zones,"multiple":true,"close-on-select":false,"placeholder":"Select zones","label":"label","track-by":"id"},model:{value:(_vm.model.zones),callback:function ($$v) {_vm.$set(_vm.model, "zones", $$v)},expression:"model.zones"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.zones.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                          Zone(s) is required\n                        ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.totalMinuteAllowed),expression:"model.totalMinuteAllowed"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted &&
                              _vm.$v.model.totalMinuteAllowed.$error,
                          },attrs:{"type":"number"},domProps:{"value":(_vm.model.totalMinuteAllowed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "totalMinuteAllowed", $event.target.value)}}}),_vm._v(" "),(
                            _vm.isSubmitted && _vm.$v.model.totalMinuteAllowed.$error
                          )?_c('div',[(!_vm.$v.model.totalMinuteAllowed.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                            Total minutes allowed is required\n                          ")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.totalMinuteAllowed.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                            Min total minutes is\n                            "+_vm._s(_vm.$v.model.totalMinuteAllowed.$params.minValue.min)+"\n                          ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.gracePriodInterval),expression:"model.gracePriodInterval"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted &&
                              _vm.$v.model.gracePriodInterval.$error,
                          },attrs:{"type":"number"},domProps:{"value":(_vm.model.gracePriodInterval)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "gracePriodInterval", $event.target.value)}}}),_vm._v(" "),(
                            _vm.isSubmitted && _vm.$v.model.gracePriodInterval.$error
                          )?_c('div',[(!_vm.$v.model.gracePriodInterval.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                            Interval is required\n                          ")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.gracePriodInterval.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                            Min interval is\n                            "+_vm._s(_vm.$v.model.gracePriodInterval.$params.minValue.min)+"\n                          ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Currency")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                            'field-error':
                              _vm.isSubmitted && !_vm.$v.model.currency.required,
                          },attrs:{"placeholder":"Select currency","label":"text","options":_vm.currencies,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.model.currency),callback:function ($$v) {_vm.$set(_vm.model, "currency", $$v)},expression:"model.currency"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.currency.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                          Currency is required\n                        ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Rate")]),_vm._v(" "),_c('currency-input',{staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.rate.$error,
                          },attrs:{"autocomplete":"off","placeholder":"Enter rate","allow-negative":false,"currency":null,"locale":_vm.moneyFormat.cultureCode,"precision":_vm.moneyFormat.numberOfDecimal},model:{value:(_vm.model.rate),callback:function ($$v) {_vm.$set(_vm.model, "rate", $$v)},expression:"model.rate"}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.rate.$error)?_c('div',[(!_vm.$v.model.rate.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                            Rate is required\n                          ")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.rate.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                            Min rate is\n                            "+_vm._s(_vm.$v.model.rate.$params.minValue.min)+"\n                          ")]):_vm._e()]):_vm._e()],1),_vm._v(" "),(_vm.isAllowToCreate || _vm.isAllowToUpdate)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onResetForm()}}},[_vm._v("\n                          Reset\n                        ")]),_vm._v(" "),(!_vm.isUpdate && _vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onSubmitForm()}}},[_vm._v("\n                          Create\n                        ")]):_vm._e(),_vm._v(" "),(_vm.isUpdate && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onSubmitForm()}}},[_vm._v("\n                          Update\n                        ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 divider-left pl-20"},[_c('div',{staticClass:"table-modal-detail"},[_c('div',{staticClass:"table-responsive table-accordion"},[_c('table',{staticClass:"table table-hover"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:item.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v("\n                                  "+_vm._s(_vm.$helper.printWaitingTimeSourceType(
                                      item.type
                                    ))+"\n                                ")]),_vm._v(" "),_c('td',[(item.zones && item.zones.length > 0)?_vm._l((item.zones),function(zone,idxZoneItem){return _c('p',{key:idxZoneItem},[_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(zone.group))]),_vm._v("\n                                      "+_vm._s(zone.name)+"\n                                    ")])}):[_vm._v(" - ")]],2),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                                  "+_vm._s(item.totalMinuteAllowed)+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                                  "+_vm._s(item.gracePriodInterval)+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                                  "+_vm._s(item.currency)+"\n                                  "+_vm._s(_vm.printMoney(item.rate))+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":!_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.onChangeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                      "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                                    ")])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.onEdit(item)}}},[_c('span',[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.onDelete(item)}}},[_c('i',{staticClass:"ic-close"})]):_vm._e()])])])}),0)])])])])])])])])])])])])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.submitDelete,"cancel":_vm.cancelDelete}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"required"},[_vm._v("\n                          Allowed Time "),_c('span',{staticClass:"--grey50"},[_vm._v("(minute)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"required"},[_vm._v("\n                          Interval "),_c('span',{staticClass:"--grey50"},[_vm._v("(minute)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"number"},[_vm._v("No")]),_vm._v(" "),_c('th',[_vm._v("Source")]),_vm._v(" "),_c('th',[_vm._v("Pick-up Zones")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                                  Allowed Time (minute)\n                                ")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Interval (minute)")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Rate")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1031:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/selling/Surcharges';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list' + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 1032:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"btn-group mb-15",attrs:{"role":"group","aria-label":"..."}},[_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.isAirportTransfer },attrs:{"type":"button"},on:{"click":function($event){return _vm.onChangeServiceType(1)}}},[_vm._v("\n                Airport Transfer\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.isHourly },attrs:{"type":"button"},on:{"click":function($event){return _vm.onChangeServiceType(2)}}},[_vm._v("\n                Hourly\n              ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter"},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.keyword),expression:"table.keyword"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Search"},domProps:{"value":(_vm.table.keyword)},on:{"keyup":function($event){return _vm.onKeyupKeyword()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.table, "keyword", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length pull-right"},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.pageSize),expression:"table.pageSize"}],staticClass:"form-control v-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "pageSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChangePageSize()}]}},_vm._l((_vm.table.pageSizes),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),0),_vm._v("\n              Entries\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive table-p15"},[_c('table',{staticClass:"table table-hover table-fix"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.id,staticClass:"detail-row"},[_c('td',[_vm._v(_vm._s(item.masterClassName))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToManageGeneralSurcharge)?_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.manageGeneralSurcharge(item)}}},[_c('span',[_vm._v("General")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToManageCancellationSurcharge)?_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.manageCancellationSurcharge(item)}}},[_c('span',[_vm._v("Cancellation")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToManagePeakPeriodSurcharge)?_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.managePeakPeriodSurcharge(item)}}},[_c('span',[_vm._v("Peak-Period")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToManageWaitingTimeSurcharge && _vm.type === 1)?_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.manageWaitingTimeSurcharge(item)}}},[_c('span',[_vm._v("Waiting-Time")])]):_vm._e()])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.recordInfo))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('nav',{attrs:{"aria-label":"..."}},[_c('paginate',{attrs:{"page-count":_vm.table.totalPages,"click-handler":_vm.onNavigateCallback,"prev-text":'Previous',"next-text":'Next',"container-class":'pagination pull-right'},model:{value:(_vm.table.pageNumber),callback:function ($$v) {_vm.$set(_vm.table, "pageNumber", $$v)},expression:"table.pageNumber"}})],1)])])])]),_vm._v(" "),(_vm.isAllowToManageGeneralSurcharge)?_c('generalSurcharge',{attrs:{"serviceType":_vm.type}}):_vm._e(),_vm._v(" "),(_vm.isAllowToManageCancellationSurcharge)?_c('cancellationSurcharge',{attrs:{"serviceType":_vm.type}}):_vm._e(),_vm._v(" "),(_vm.isAllowToManagePeakPeriodSurcharge)?_c('peakPeriodSurcharge',{attrs:{"serviceType":_vm.type}}):_vm._e(),_vm._v(" "),(_vm.isAllowToManageWaitingTimeSurcharge)?_c('waitingTimeSurcharge'):_vm._e(),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Booker Tariff")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("Surcharge")])])]),_vm._v(" "),_c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-left"},[_c('h2',[_vm._v("\n                  Surcharge "),_c('span',[_c('i',{staticClass:"ic-price-calculator"})])]),_vm._v(" "),_c('p',[_vm._v("Set surcharge for Booker Tariff.")])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Class")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Surcharge_vue__ = __webpack_require__(778);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aec8a6e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Surcharge_vue__ = __webpack_require__(1032);
function injectStyle (ssrContext) {
  __webpack_require__(1015)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aec8a6e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Surcharge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aec8a6e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Surcharge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(468));

var _alphaNum = _interopRequireDefault(__webpack_require__(471));

var _numeric = _interopRequireDefault(__webpack_require__(472));

var _between = _interopRequireDefault(__webpack_require__(473));

var _email = _interopRequireDefault(__webpack_require__(474));

var _ipAddress = _interopRequireDefault(__webpack_require__(475));

var _macAddress = _interopRequireDefault(__webpack_require__(476));

var _maxLength = _interopRequireDefault(__webpack_require__(477));

var _minLength = _interopRequireDefault(__webpack_require__(478));

var _required = _interopRequireDefault(__webpack_require__(479));

var _requiredIf = _interopRequireDefault(__webpack_require__(480));

var _requiredUnless = _interopRequireDefault(__webpack_require__(481));

var _sameAs = _interopRequireDefault(__webpack_require__(482));

var _url = _interopRequireDefault(__webpack_require__(483));

var _or = _interopRequireDefault(__webpack_require__(484));

var _and = _interopRequireDefault(__webpack_require__(485));

var _not = _interopRequireDefault(__webpack_require__(486));

var _minValue = _interopRequireDefault(__webpack_require__(487));

var _maxValue = _interopRequireDefault(__webpack_require__(488));

var _integer = _interopRequireDefault(__webpack_require__(489));

var _decimal = _interopRequireDefault(__webpack_require__(490));

var helpers = _interopRequireWildcard(__webpack_require__(465));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    idModal: {
      type: String,
      default: "deletemodal"
    },
    subContent: {
      type: String,
      default: "Do you want to delete this record? This process cannot be undone."
    }
  },
  methods: {
    cancel: function cancel() {
      $("#" + this.idModal).modal("hide");
      this.$emit("cancel");
    },
    submit: function submit() {
      $("#" + this.idModal).modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(470).withParams : __webpack_require__(235).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__ = __webpack_require__(492);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":_vm.idModal}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[_vm._m(0),_vm._v(" "),_c('header',[_vm._v("Are you sure?")]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.subContent)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("\n                  Cancel\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  Yes, delete\n                ")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-icon"},[_c('i',{staticClass:"ic-close"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(498), __esModule: true };

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(36);
__webpack_require__(25);
module.exports = __webpack_require__(499);


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var get = __webpack_require__(58);
module.exports = __webpack_require__(1).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(242);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(495);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(512), __esModule: true };

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(513);
module.exports = __webpack_require__(1).Object.entries;


/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(5);
var $entries = __webpack_require__(514)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(6);
var getKeys = __webpack_require__(19);
var toIObject = __webpack_require__(10);
var isEnum = __webpack_require__(27).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/master/zones";

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/list" + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/list/active").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllGroups: function getAllGroups() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/list/group").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getZonesByGroupId: function getZonesByGroupId(params) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/by-group?" + params)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getLocation: function getLocation(group, id) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var url, queries;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              url = endpoint + "/location";
              queries = [];


              if (id) {
                queries.push("id=" + id);
              }

              if (group) {
                queries.push("group=" + group);
              }

              if (queries.length > 0) {
                url += "?" + queries.join("&");
              }

              _context5.next = 7;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 7:
              return _context5.abrupt("return", _context5.sent);

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  create: function create(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  update: function update(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt("return", _context7.sent);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  delete: function _delete(id) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ("/" + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt("return", _context8.sent);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  }
});

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/exchangeRates';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(providerRate) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/' + providerRate)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllProviders: function getAllProviders() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/providers').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getMapping: function getMapping() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/item/map').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getCurrencySelection: function getCurrencySelection() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/currency').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  createMapping: function createMapping(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/map', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  updateMapping: function updateMapping(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/map', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  updateRate: function updateRate(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/rate', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  }
});

/***/ }),

/***/ 603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/master/peakPeriods";

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/list").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllByFilter: function getAllByFilter(month, year, search) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/list/filter?month=" + month + "&year=" + year + "&search=" + search)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllById: function getAllById(id) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/list/" + id)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  create: function create(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  update: function update(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ("/" + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_master_sellingTariff_GeneralSurcharge__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_master_sellingTariff_CancellationSurcharge__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_master_sellingTariff_PeakPeriodSurcharge__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_master_sellingTariff_WaitingTimeSurcharge__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_master_sellingTariff_sellingTariffSurchargeService_js__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_master_exchangeRate_exchangeRateService_js__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_master_zone_zoneService_js__ = __webpack_require__(515);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    generalSurcharge: __WEBPACK_IMPORTED_MODULE_6__components_master_sellingTariff_GeneralSurcharge__["a" /* default */],
    cancellationSurcharge: __WEBPACK_IMPORTED_MODULE_7__components_master_sellingTariff_CancellationSurcharge__["a" /* default */],
    peakPeriodSurcharge: __WEBPACK_IMPORTED_MODULE_8__components_master_sellingTariff_PeakPeriodSurcharge__["a" /* default */],
    waitingTimeSurcharge: __WEBPACK_IMPORTED_MODULE_9__components_master_sellingTariff_WaitingTimeSurcharge__["a" /* default */]
  },
  computed: {
    isServicesExist: function isServicesExist() {
      return this.allServices && this.allServices !== null;
    },
    isAllowToRead: function isAllowToRead() {
      return this.isServicesExist && (this.allServices["SellingTariffGeneralSurcharge"] || this.allServices["SellingTariffCancellationSurcharge"] || this.allServices["SellingTariffPeakPeriodSurcharge"] || this.allServices["SellingTariffWaitingTimeSurcharge"]);
    },
    isAllowToManageGeneralSurcharge: function isAllowToManageGeneralSurcharge() {
      return this.isServicesExist && this.allServices["SellingTariffGeneralSurcharge"].includes("Read");
    },
    isAllowToManageCancellationSurcharge: function isAllowToManageCancellationSurcharge() {
      return this.isServicesExist && this.allServices["SellingTariffCancellationSurcharge"].includes("Read");
    },
    isAllowToManagePeakPeriodSurcharge: function isAllowToManagePeakPeriodSurcharge() {
      return this.isServicesExist && this.allServices["SellingTariffPeakPeriodSurcharge"].includes("Read");
    },
    isAllowToManageWaitingTimeSurcharge: function isAllowToManageWaitingTimeSurcharge() {
      return this.isServicesExist && this.allServices["SellingTariffWaitingTimeSurcharge"].includes("Read");
    },
    recordInfo: function recordInfo() {
      return this.table.totalRecords > 1 ? this.table.totalRecords + " Records" : this.table.totalRecords + " Record";
    },
    isAirportTransfer: function isAirportTransfer() {
      return this.type === 1;
    },
    isHourly: function isHourly() {
      return this.type === 2;
    }
  },
  data: function data() {
    return {
      validationErrors: {},
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100]
      },
      formatter: null,
      moneyFormat: null,
      allServices: null,
      items: [],
      currencies: [],
      zones: [],
      groupZone: [],
      isLoading: false,
      msg: "Please wait",
      type: 1
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.$store.dispatch("setting/getAllPublic");

            case 3:
              publicSettings = _context.sent;

              _this.table.pageSize = _this.$helper.extractSetting(publicSettings, "PageSize", 25);

              _context.next = 7;
              return _this.$store.dispatch("user/getProfile");

            case 7:
              profile = _context.sent;

              _this.allServices = profile.services;

              if (!_this.isAllowToRead) {
                _context.next = 13;
                break;
              }

              _context.next = 12;
              return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([_this.getAll(), _this.getCurrencySelection(), _this.getAllZones(), _this.getAllGroupZone()]);

            case 12:
              if (_this.moneyFormat) {
                _this.formatter = new Intl.NumberFormat(_this.moneyFormat.cultureCode, {
                  style: "currency",
                  currency: _this.moneyFormat.currencyCode,
                  currencyDisplay: "code",
                  minimumFractionDigits: _this.moneyFormat.numberOfDecimal
                });
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  updated: function updated() {
    this.$helper.collapseMenu("selling-tariff");
    this.$helper.setNavigationClass("selling-surcharge-link");
  },

  methods: {
    onChangeServiceType: function onChangeServiceType(value) {
      this.type = value;
      this.getAll();
    },
    onChangePageSize: function onChangePageSize() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.table.pageNumber = 1;
                _context2.next = 3;
                return _this2.getAll();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onKeyupKeyword: function onKeyupKeyword() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this3;

                if (self.timer) {
                  clearTimeout(self.timer);
                  self.timer = null;
                }
                self.timer = setTimeout(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(_) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            self.table.pageNumber = 1;
                            _context3.next = 3;
                            return self.getAll();

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), 500);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    onNavigateCallback: function onNavigateCallback(pageNumber) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.table.pageNumber = pageNumber;
                _context5.next = 3;
                return _this4.getAll();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    getAll: function getAll() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var filter, response, index;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this5.isLoading = true;
                filter = "?page=" + _this5.table.pageNumber + "&size=" + _this5.table.pageSize;

                if (_this5.table.keyword !== null && _this5.table.keyword !== "") {
                  filter += "&search=" + _this5.table.keyword;
                }
                _context6.next = 6;
                return __WEBPACK_IMPORTED_MODULE_10__services_master_sellingTariff_sellingTariffSurchargeService_js__["a" /* default */].getAll(filter);

              case 6:
                response = _context6.sent;

                _this5.items = response.data.items;
                _this5.moneyFormat = response.data.moneyFormat;
                _this5.table.totalPages = response.totalPages;
                _this5.table.totalRecords = response.totalRecords;
                _context6.next = 16;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](0);

                if (_context6.t0.errors) {
                  for (index = 0; index < _context6.t0.errors.length; index++) {
                    _this5.$notification.error(_context6.t0.errors[index], { title: "Error" });
                  }
                }

              case 16:
                _context6.prev = 16;

                _this5.isLoading = false;
                return _context6.finish(16);

              case 19:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5, [[0, 13, 16, 19]]);
      }))();
    },
    getCurrencySelection: function getCurrencySelection() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__services_master_exchangeRate_exchangeRateService_js__["a" /* default */].getCurrencySelection();

              case 2:
                response = _context7.sent;

                if (response && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(response).length > 0) {
                  _this6.currencies = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(response).map(function (_ref2) {
                    var _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
                        key = _ref3[0],
                        value = _ref3[1];

                    return { value: key, text: value };
                  });
                }

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    },
    getAllZones: function getAllZones() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var i, item;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__services_master_zone_zoneService_js__["a" /* default */].getAllActive();

              case 2:
                _this7.zones = _context8.sent;


                for (i = 0; i < _this7.zones.length; i++) {
                  item = _this7.zones[i];

                  item.label = item.group + " " + item.name;
                }

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this7);
      }))();
    },
    getAllGroupZone: function getAllGroupZone() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var i, item;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__services_master_zone_zoneService_js__["a" /* default */].getAllGroups();

              case 2:
                _this8.groupZone = _context9.sent;

                for (i = 0; i < _this8.groupZone.length; i++) {
                  item = _this8.groupZone[i];

                  item.label = item.name;
                }

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this8);
      }))();
    },
    manageGeneralSurcharge: function manageGeneralSurcharge(item) {
      // publish message
      this.$eventBus.$emit("initializeSellingTariffGeneralSurcharge", item, this.moneyFormat, this.formatter, this.currencies, this.zones, this.groupZone);
    },
    manageCancellationSurcharge: function manageCancellationSurcharge(item) {
      // publish message
      this.$eventBus.$emit("initializeSellingTariffCancellationSurcharge", item, this.moneyFormat, this.formatter);
    },
    managePeakPeriodSurcharge: function managePeakPeriodSurcharge(item) {
      // publish message
      this.$eventBus.$emit("initializeSellingTariffPeakPeriodSurcharge", item, this.moneyFormat, this.formatter, this.currencies, this.zones, this.groupZone);
    },
    manageWaitingTimeSurcharge: function manageWaitingTimeSurcharge(item) {
      // publish message
      this.$eventBus.$emit("initializeSellingTariffWaitingTimeSurcharge", item, this.moneyFormat, this.formatter, this.currencies, this.zones);
    }
  }
});

/***/ }),

/***/ 779:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_numberHelper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_constants__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_master_sellingTariff_sellingTariffGeneralSurchargeService_js__ = __webpack_require__(1020);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var defaultModel = {
  id: null,
  masterClassId: null,
  type: null,
  currency: null,
  rateAmountType: 1, // flat
  flatRateAmount: null,
  hourlyRateAmount: null,
  garageTimeBandMinimum: null,
  garageTimeBandMinutes: null,
  nightTimeSurchargeStart: "19:00",
  nightTimeSurchargeEnd: "06:59",
  weekendSurchargeDays: [],
  minimumHourlyHire: null,
  minuteRoundingTime: null,
  remark: null,
  isActive: true,
  zones: [],
  groupZones: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    },
    showCurrencyField: function showCurrencyField() {
      return this.model.rateAmountType !== 2;
    },
    validationCurrencyField: function validationCurrencyField() {
      return this.model.rateAmountType !== 2 ? { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] } : {};
    }
  },
  props: ["serviceType"],
  data: function data() {
    return {
      isLoading: false,
      msg: "Please wait",
      isOpen: false,
      selectedMasterClass: null,
      isUpdate: false,
      moneyFormat: null,
      formatter: null,
      timestampItem: null,
      activeTab: __WEBPACK_IMPORTED_MODULE_6__models_constants__["h" /* GeneralSurchargeType */].NightTime,
      isSubmitted: false,
      itemIdToBeDeleted: null,
      model: {},
      amountTypes: __WEBPACK_IMPORTED_MODULE_6__models_constants__["a" /* AmountTypes */],
      weekends: __WEBPACK_IMPORTED_MODULE_6__models_constants__["f" /* DaysArray */],
      generalSurchargeType: __WEBPACK_IMPORTED_MODULE_6__models_constants__["h" /* GeneralSurchargeType */],
      allPermissions: [],
      currencies: [],
      zones: [],
      groupZones: [],
      surcharges: []
    };
  },
  validations: function validations() {
    var v = {
      model: {
        currency: this.validationCurrencyField,
        zones: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        groupZones: {}
      }
    };

    if (this.serviceType === 2) {
      v.model = {
        currency: this.validationCurrencyField,
        zones: {},
        groupZones: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
      };
    }
    return v;
  },
  created: function created() {
    this.$eventBus.$on("initializeSellingTariffGeneralSurcharge", this.initialize);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("initializeSellingTariffGeneralSurcharge");
  },

  methods: {
    initialize: function initialize(masterClass, moneyFormat, formatter, currencies, zones, groupZone) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var profile, permissions;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.isLoading = true;
                _this.isOpen = true;
                _this.selectedMasterClass = masterClass;
                _this.moneyFormat = moneyFormat;
                _this.formatter = formatter;
                _this.currencies = currencies;
                _this.zones = zones;
                _this.groupZones = groupZone;

                _context.next = 11;
                return _this.$store.dispatch("user/getProfile");

              case 11:
                profile = _context.sent;
                permissions = profile.services["SellingTariffGeneralSurcharge"];

                if (permissions) {
                  _this.allPermissions = permissions;
                }

                if (_this.isAllowToRead) {
                  _this.activeTab = _this.generalSurchargeType.NightTime;

                  _this.getAll().then(function () {
                    $(_this.$refs.vuemodal).modal({
                      backdrop: "static",
                      keyboard: false
                    });
                    _this.onResetForm();
                  });
                }

              case 15:
                _context.prev = 15;

                _this.isLoading = false;
                return _context.finish(15);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0,, 15, 18]]);
      }))();
    },
    onCloseModal: function onCloseModal() {
      this.isOpen = false;
      $(this.$refs.vuemodal).modal("hide");
    },
    onEdit: function onEdit(item) {
      this.isUpdate = true;
      this.timestampItem = item.modifiedDate.stringFullDate;
      this.bindModel(item);
    },
    onDelete: function onDelete(item) {
      this.itemIdToBeDeleted = item.id;
      $("#deletemodal").modal();
    },
    onChangeActiveTab: function onChangeActiveTab(type) {
      this.activeTab = type;
      this.getAll();
    },
    onChangeStatus: function onChangeStatus(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var payload, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLoading = true;
                _this2.isUpdate = true;
                _this2.bindModel(item);
                _this2.model.isActive = !!_this2.model.isActive;

                _context2.prev = 4;
                payload = _this2.constructPayload();
                _context2.next = 8;
                return _this2.submitUpdate(payload);

              case 8:
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](4);

                if (_context2.t0.errors) {
                  for (index = 0; index < _context2.t0.errors.length; index++) {
                    _this2.$notification.error(_context2.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context2.prev = 13;

                _this2.isLoading = false;
                return _context2.finish(13);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[4, 10, 13, 16]]);
      }))();
    },
    onResetForm: function onResetForm() {
      this.isUpdate = false;
      this.timestampItem = null;
      this.clearValidation();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel);
    },
    bindModel: function bindModel(item) {
      this.model.id = item.id;
      this.model.masterClassId = item.masterClassId;
      // this.model.amountType = item.amountType;
      this.model.currency = item.currency;
      this.model.rateAmountType = item.amountType;
      this.model.flatRateAmount = item.flatRateAmount;
      this.model.hourlyRateAmount = item.hourlyRateAmount;
      this.model.garageTimeBandMinimum = item.garageTimeBandMinimum;
      this.model.garageTimeBandMinutes = item.garageTimeBandMinutes;
      this.model.minimumHourlyHire = item.minimumHourlyHire;
      this.model.minuteRoundingTime = item.minuteRoundingTime;
      this.model.nightTimeSurchargeStart = item.nightTimeSurchargeStart;
      this.model.nightTimeSurchargeEnd = item.nightTimeSurchargeEnd;
      this.model.weekendSurchargeDays = item.weekendSurchargeDays;
      this.model.remark = item.remark;
      this.model.isActive = item.isActive;
      this.model.zones = null;
      this.model.groupZones = null;
      if (item.zones !== null) {
        this.model.zones = this.zones.filter(function (array) {
          return item.zones.some(function (filter) {
            return filter.id === array.id;
          });
        });
      }
      if (item.zoneGroups !== null) {
        this.model.groupZones = this.groupZones.filter(function (array) {
          return item.zoneGroups.some(function (filter) {
            return filter.id === array.id;
          });
        });
      }
    },
    constructPayload: function constructPayload() {
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel);

      if (this.isUpdate) {
        payload.id = this.model.id;
        payload.isActive = this.model.isActive;
      }

      payload.masterClassId = this.selectedMasterClass.masterClassId;
      payload.type = this.activeTab;
      payload.currency = this.model.currency;
      payload.rateAmountType = this.model.rateAmountType;
      payload.flatRateAmount = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberHelper__["g" /* tryParseFloat */])(this.model.flatRateAmount);
      payload.hourlyRateAmount = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberHelper__["g" /* tryParseFloat */])(this.model.hourlyRateAmount);
      if (this.model.zones !== null) {
        payload.zones = this.model.zones.map(function (zone) {
          return zone.id;
        });
      }
      if (this.model.groupZones !== null) {
        payload.groupZones = this.model.groupZones.map(function (zone) {
          return zone.id;
        });
      }
      payload.serviceType = this.serviceType;

      if (this.activeTab === this.generalSurchargeType.NightTime) {
        payload.nightTimeSurchargeStart = this.model.nightTimeSurchargeStart;
        payload.nightTimeSurchargeEnd = this.model.nightTimeSurchargeEnd;
      }

      if (this.activeTab === this.generalSurchargeType.Weekend) {
        payload.weekendSurchargeDays = this.model.weekendSurchargeDays;
      }

      if (this.activeTab === this.generalSurchargeType.GarageTime) {
        payload.flatRateAmount = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberHelper__["h" /* tryParseInt */])(this.model.flatRateAmount);
        payload.garageTimeBandMinimum = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberHelper__["h" /* tryParseInt */])(this.model.garageTimeBandMinimum);
        payload.garageTimeBandMinutes = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberHelper__["h" /* tryParseInt */])(this.model.garageTimeBandMinutes);
      }

      if (this.activeTab === this.generalSurchargeType.Others) {
        payload.minimumHourlyHire = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberHelper__["h" /* tryParseInt */])(this.model.minimumHourlyHire);
        payload.minuteRoundingTime = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberHelper__["h" /* tryParseInt */])(this.model.minuteRoundingTime);
        payload.remark = this.model.remark;
      }

      return payload;
    },
    onSubmitForm: function onSubmitForm() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var payload, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isSubmitted = true;
                _this3.$v.model.$touch();

                if (!_this3.$v.model.$error) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                _context3.prev = 4;

                _this3.isLoading = true;
                payload = _this3.constructPayload();

                if (!_this3.isUpdate) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 10;
                return _this3.submitUpdate(payload);

              case 10:
                _context3.next = 14;
                break;

              case 12:
                _context3.next = 14;
                return _this3.submitCreate(payload);

              case 14:
                _context3.next = 19;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](4);

                if (_context3.t0.errors) {
                  for (index = 0; index < _context3.t0.errors.length; index++) {
                    _this3.$notification.error(_context3.t0.errors[index], { title: "Error" });
                  }
                }

              case 19:
                _context3.prev = 19;

                _this3.isLoading = false;
                return _context3.finish(19);

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[4, 16, 19, 22]]);
      }))();
    },
    getAll: function getAll() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.isLoading = true;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__services_master_sellingTariff_sellingTariffGeneralSurchargeService_js__["a" /* default */].getAll(_this4.selectedMasterClass.masterClassId, _this4.activeTab, _this4.serviceType);

              case 4:
                _this4.surcharges = _context4.sent;
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 10:
                _context4.prev = 10;

                _this4.isLoading = false;
                return _context4.finish(10);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 7, 10, 13]]);
      }))();
    },
    clearValidation: function clearValidation() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    submitCreate: function submitCreate(payload) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__services_master_sellingTariff_sellingTariffGeneralSurchargeService_js__["a" /* default */].create(payload);

              case 2:
                _this5.onResetForm();

                _this5.getAll().then(function () {
                  _this5.$notification.success("Successfully created.", {
                    title: "Success"
                  });
                });

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    submitUpdate: function submitUpdate(payload) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__services_master_sellingTariff_sellingTariffGeneralSurchargeService_js__["a" /* default */].update(payload);

              case 2:
                _this6.onResetForm();

                _this6.getAll().then(function () {
                  _this6.$notification.success("Successfully updated.", {
                    title: "Success"
                  });
                });

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    submitDelete: function submitDelete() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this7.isLoading = true;
                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__services_master_sellingTariff_sellingTariffGeneralSurchargeService_js__["a" /* default */].delete(_this7.itemIdToBeDeleted);

              case 4:
                _this7.itemIdToBeDeleted = null;

                _this7.getAll().then(function () {
                  _this7.$notification.success("Successfully deleted.", {
                    title: "Success"
                  });
                });
                _context7.next = 11;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](0);

                if (_context7.t0.errors) {
                  for (index = 0; index < _context7.t0.errors.length; index++) {
                    _this7.$notification.error(_context7.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context7.prev = 11;

                _this7.isLoading = false;
                setTimeout(function () {
                  $("body").addClass("modal-open");
                }, 500);
                return _context7.finish(11);

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 8, 11, 15]]);
      }))();
    },
    cancelDelete: function cancelDelete() {
      setTimeout(function () {
        $("body").addClass("modal-open");
      }, 500);
    },
    printMoney: function printMoney(value) {
      return this.formatter ? this.formatter.format(value).replace(/[a-z]{3}/i, "").trim() : value;
    },
    renderRateIntoTable: function renderRateIntoTable(amountType, amount, currency) {
      if (amountType === 1) {
        if (amount) {
          return currency + " " + this.printMoney(amount);
        } else {
          return "-";
        }
      }

      if (amountType === 2) {
        if (amount) {
          return amount + " %";
        } else {
          return "-";
        }
      }
    },
    renderDaysIntoTable: function renderDaysIntoTable(days) {
      if (days && days.length > 0) {
        return days.join(", ");
      } else {
        return "-";
      }
    }
  },
  watch: {
    // 'model.garageTimeBandMinutes': {
    //   deep: true,
    //   handler(v) {
    //     if (v !== undefined && (v !== null && v.length === 0)) {
    //       this.model.garageTimeBandMinutes = 0;
    //     }
    //   }
    // },
    // 'model.garageTimeBandMinimum': {
    //   deep: true,
    //   handler(v) {
    //     if (v !== undefined && (v !== null && v.length === 0)) {
    //       this.model.garageTimeBandMinimum = 0;
    //     }
    //   }
    // },
  }
});

/***/ }),

/***/ 780:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_master_sellingTariff_sellingTariffCancellationSurchargeService_js__ = __webpack_require__(1023);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var defaultModel = {
  id: null,
  masterClassId: null,
  startHourBeforePickup: null,
  endHourBeforePickup: null,
  endHourBeforePickupIsInfinite: false,
  maximumChargeHour: null,
  maximumChargeHourIsInfinite: null,
  totalHourBeforePickup: null,
  percentageCharge: null,
  isActive: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    },
    validationRuleEndOfRangeHour: function validationRuleEndOfRangeHour() {
      return this.model && this.model.endHourBeforePickupIsInfinite ? {} : { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] };
    },
    validationRuleMaximumChargeHour: function validationRuleMaximumChargeHour() {
      return this.model && this.model.maximumChargeHourIsInfinite ? {} : { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) };
    }
  },
  props: ["serviceType"],
  data: function data() {
    return {
      isSubmitted: false,
      isOpen: false,
      allPermissions: [],
      selectedMasterClass: null,
      formatter: null,
      moneyFormat: null,
      timestampItem: null,
      itemIdToBeDeleted: null,
      items: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    var v = {
      model: {
        startHourBeforePickup: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) },
        endHourBeforePickup: this.validationRuleEndOfRangeHour,
        percentageCharge: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) },
        maximumChargeHour: {}
      }
    };

    if (this.serviceType === 2) {
      v.model = {
        startHourBeforePickup: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) },
        endHourBeforePickup: this.validationRuleEndOfRangeHour,
        percentageCharge: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) },
        maximumChargeHour: this.validationRuleMaximumChargeHour
      };
    }

    return v;
  },
  created: function created() {
    this.$eventBus.$on("initializeSellingTariffCancellationSurcharge", this.initialize);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("initializeSellingTariffCancellationSurcharge");
  },

  methods: {
    initialize: function initialize(masterClass, moneyFormat, formatter) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var profile, permissions;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.isLoading = true;
                _this.isOpen = true;
                _this.selectedMasterClass = masterClass;
                _this.moneyFormat = moneyFormat;
                _this.formatter = formatter;

                _context.next = 8;
                return _this.$store.dispatch("user/getProfile");

              case 8:
                profile = _context.sent;
                permissions = profile.services["SellingTariffCancellationSurcharge"];

                if (permissions) {
                  _this.allPermissions = permissions;
                }

                if (_this.isAllowToRead) {
                  _this.getAll().then(function () {
                    $(_this.$refs.vuemodal).modal({
                      backdrop: "static",
                      keyboard: false
                    });
                    _this.onResetForm();
                  });
                }

              case 12:
                _context.prev = 12;

                _this.isLoading = false;
                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0,, 12, 15]]);
      }))();
    },
    onResetForm: function onResetForm() {
      this.isUpdate = false;
      this.timestampItem = null;
      this.clearValidation();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel);
    },
    clearValidation: function clearValidation() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    bindModel: function bindModel(item) {
      this.model.id = item.id;
      this.model.masterClassId = item.masterClassId;
      this.model.startHourBeforePickup = item.startHourBeforePickup;
      this.model.maximumChargeHour = item.maximumChargeHour;
      this.model.totalHourBeforePickup = item.totalHourBeforePickup;
      this.model.percentageCharge = item.percentageCharge;
      this.model.isActive = item.isActive;

      if (item.endHourBeforePickup === -1 || item.endHourBeforePickup === null) {
        this.model.endHourBeforePickupIsInfinite = true;
        this.model.endHourBeforePickup = null;
      } else {
        this.model.endHourBeforePickupIsInfinite = false;
        this.model.endHourBeforePickup = item.endHourBeforePickup;
      }

      if (item.maximumChargeHour === -1 || item.maximumChargeHour === null) {
        this.model.maximumChargeHourIsInfinite = true;
        this.model.maximumChargeHour = null;
      } else {
        this.model.maximumChargeHourIsInfinite = false;
        this.model.maximumChargeHour = item.maximumChargeHour;
      }
    },
    onCloseModal: function onCloseModal() {
      this.isOpen = false;
      $(this.$refs.vuemodal).modal("hide");
    },
    onEdit: function onEdit(item) {
      this.isUpdate = true;
      this.timestampItem = item.modifiedDate.stringFullDate;
      this.bindModel(item);
    },
    onDelete: function onDelete(item) {
      this.itemIdToBeDeleted = item.id;
      $("#deletemodal").modal();
    },
    constructPayload: function constructPayload() {
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel);

      if (this.isUpdate) {
        payload.id = this.model.id;
        payload.isActive = this.model.isActive;
      }

      payload.masterClassId = this.selectedMasterClass.masterClassId;
      payload.startHourBeforePickup = this.model.startHourBeforePickup;
      payload.maximumChargeHour = this.model.maximumChargeHour;
      payload.totalHourBeforePickup = this.model.totalHourBeforePickup;
      payload.percentageCharge = this.model.percentageCharge;
      payload.serviceType = this.serviceType;
      payload.endHourBeforePickupIsInfinite = this.model.endHourBeforePickupIsInfinite;
      payload.maximumChargeHourIsInfinite = this.model.maximumChargeHourIsInfinite;

      if (this.model.endHourBeforePickupIsInfinite) {
        payload.endHourBeforePickup = -1;
      } else {
        payload.endHourBeforePickup = this.model.endHourBeforePickup;
      }

      if (this.model.maximumChargeHourIsInfinite) {
        payload.maximumChargeHour = -1;
      } else {
        payload.maximumChargeHour = this.model.maximumChargeHour;
      }

      return payload;
    },
    getAll: function getAll() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_sellingTariff_sellingTariffCancellationSurchargeService_js__["a" /* default */].getAll(_this2.selectedMasterClass.masterClassId, _this2.serviceType);

              case 2:
                _this2.items = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    submitDelete: function submitDelete() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this3.isLoading = true;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_sellingTariff_sellingTariffCancellationSurchargeService_js__["a" /* default */].delete(_this3.itemIdToBeDeleted);

              case 4:
                _this3.itemIdToBeDeleted = null;

                _this3.getAll().then(function () {
                  _this3.$notification.success("Successfully deleted.", {
                    title: "Success"
                  });
                });
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                if (_context3.t0.errors) {
                  for (index = 0; index < _context3.t0.errors.length; index++) {
                    _this3.$notification.error(_context3.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context3.prev = 11;

                _this3.isLoading = false;
                setTimeout(function () {
                  $("body").addClass("modal-open");
                }, 500);
                return _context3.finish(11);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 8, 11, 15]]);
      }))();
    },
    cancelDelete: function cancelDelete() {
      setTimeout(function () {
        $("body").addClass("modal-open");
      }, 500);
    },
    onSubmitForm: function onSubmitForm() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var payload, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.isSubmitted = true;
                _this4.$v.model.$touch();

                if (!_this4.$v.model.$error) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return");

              case 4:
                _context4.prev = 4;

                _this4.isLoading = true;
                payload = _this4.constructPayload();

                if (!_this4.isUpdate) {
                  _context4.next = 12;
                  break;
                }

                _context4.next = 10;
                return _this4.submitUpdate(payload);

              case 10:
                _context4.next = 14;
                break;

              case 12:
                _context4.next = 14;
                return _this4.submitCreate(payload);

              case 14:
                _context4.next = 19;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4["catch"](4);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 19:
                _context4.prev = 19;

                _this4.isLoading = false;
                return _context4.finish(19);

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[4, 16, 19, 22]]);
      }))();
    },
    onChangeStatus: function onChangeStatus(item) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var payload, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.isLoading = true;
                _this5.isUpdate = true;
                _this5.bindModel(item);
                _this5.model.isActive = !!_this5.model.isActive;

                _context5.prev = 4;
                payload = _this5.constructPayload();
                _context5.next = 8;
                return _this5.submitUpdate(payload);

              case 8:
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](4);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context5.prev = 13;

                _this5.isLoading = false;
                return _context5.finish(13);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[4, 10, 13, 16]]);
      }))();
    },
    submitCreate: function submitCreate(payload) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_sellingTariff_sellingTariffCancellationSurchargeService_js__["a" /* default */].create(payload);

              case 2:
                _this6.onResetForm();

                _this6.getAll().then(function () {
                  _this6.$notification.success("Successfully created.", {
                    title: "Success"
                  });
                });

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    submitUpdate: function submitUpdate(payload) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_sellingTariff_sellingTariffCancellationSurchargeService_js__["a" /* default */].update(payload);

              case 2:
                _this7.onResetForm();

                _this7.getAll().then(function () {
                  _this7.$notification.success("Successfully updated.", {
                    title: "Success"
                  });
                });

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    changeInfinite: function changeInfinite() {
      this.model.endHourBeforePickup = null;
    },
    changeMaxChargeHoursInInfinite: function changeMaxChargeHoursInInfinite() {
      this.model.maximumChargeHour = null;
    }
  }
});

/***/ }),

/***/ 781:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_constants__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_master_peakPeriod_peakPeriodService_js__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_master_sellingTariff_sellingTariffPeakPeriodSurchargeService_js__ = __webpack_require__(1026);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var defaultModel = {
  id: null,
  masterClassId: null,
  peakPeriodId: null,
  currency: null,
  amountType: 1, // flat
  flatRate: null,
  isActive: true,
  zones: [],
  zoneIds: [],
  groupZones: [],
  groupZoneIds: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    },
    showCurrencyField: function showCurrencyField() {
      return this.model.amountType !== 2;
    },
    validationCurrencyField: function validationCurrencyField() {
      return this.model.amountType !== 2 ? { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(3) } : {};
    }
  },
  props: ["serviceType"],
  data: function data() {
    return {
      isSubmitted: false,
      isOpen: false,
      allPermissions: [],
      formatter: null,
      moneyFormat: null,
      selectedMasterClass: null,
      timestampItem: null,
      itemIdToBeDeleted: null,
      amountTypes: __WEBPACK_IMPORTED_MODULE_5__models_constants__["a" /* AmountTypes */],
      peakPeriods: [],
      items: [],
      currencies: [],
      zones: [],
      groupZones: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    var v = {
      model: {
        peakPeriodId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        zones: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        groupZones: {},
        currency: this.validationCurrencyField,
        flatRate: { minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) }
      }
    };

    if (this.serviceType === 2) {
      v.model = {
        peakPeriodId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        zones: {},
        groupZones: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        currency: this.validationCurrencyField,
        flatRate: { minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) }
      };
    }
    return v;
  },
  created: function created() {
    this.$eventBus.$on("initializeSellingTariffPeakPeriodSurcharge", this.initialize);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("initializeSellingTariffPeakPeriodSurcharge");
  },

  methods: {
    initialize: function initialize(masterClass, moneyFormat, formatter, currencies, zones, groupZone) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var profile, permissions;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.isLoading = true;
                _this.isOpen = true;
                _this.selectedMasterClass = masterClass;
                _this.moneyFormat = moneyFormat;
                _this.formatter = formatter;
                _this.currencies = currencies;
                _this.zones = zones;
                _this.groupZones = groupZone;

                _context.next = 11;
                return _this.$store.dispatch("user/getProfile");

              case 11:
                profile = _context.sent;
                permissions = profile.services["BuyingTariffPeakPeriodSurcharge"];

                if (permissions) {
                  _this.allPermissions = permissions;
                }

                if (_this.isAllowToRead) {
                  _this.getAll().then(function () {
                    _this.getPeakPeriods();
                    $(_this.$refs.vuemodal).modal({
                      backdrop: "static",
                      keyboard: false
                    });
                    _this.onResetForm();
                  });
                }

              case 15:
                _context.prev = 15;

                _this.isLoading = false;
                return _context.finish(15);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0,, 15, 18]]);
      }))();
    },
    onResetForm: function onResetForm() {
      this.isUpdate = false;
      this.timestampItem = null;
      this.clearValidation();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel);
    },
    clearValidation: function clearValidation() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    onCloseModal: function onCloseModal() {
      this.isOpen = false;
      $(this.$refs.vuemodal).modal("hide");
    },
    printMoney: function printMoney(value) {
      return this.formatter !== null ? this.formatter.format(value).replace(/[a-z]{3}/i, "").trim() : value;
    },
    getAll: function getAll() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__services_master_sellingTariff_sellingTariffPeakPeriodSurchargeService_js__["a" /* default */].getAll(_this2.selectedMasterClass.masterClassId, _this2.serviceType);

              case 2:
                _this2.items = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getPeakPeriods: function getPeakPeriods() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_peakPeriod_peakPeriodService_js__["a" /* default */].getAll();

              case 2:
                _this3.peakPeriods = _context3.sent;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    submitDelete: function submitDelete() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.isLoading = true;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__services_master_sellingTariff_sellingTariffPeakPeriodSurchargeService_js__["a" /* default */].delete(_this4.itemIdToBeDeleted);

              case 4:
                _this4.itemIdToBeDeleted = null;

                _this4.getAll().then(function () {
                  _this4.$notification.success("Successfully deleted.", {
                    title: "Success"
                  });
                });
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context4.prev = 11;

                _this4.isLoading = false;
                setTimeout(function () {
                  $("body").addClass("modal-open");
                }, 500);
                return _context4.finish(11);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 8, 11, 15]]);
      }))();
    },
    cancelDelete: function cancelDelete() {
      setTimeout(function () {
        $("body").addClass("modal-open");
      }, 500);
    },
    bindModel: function bindModel(item) {
      this.model.id = item.id;
      this.model.masterClassId = item.masterClassId;
      this.model.peakPeriodId = item.peakPeriodId;
      this.model.currency = item.currency;
      this.model.amountType = item.amountType;
      this.model.flatRate = item.flatRate;
      this.model.isActive = item.isActive;
      this.model.zones = null;
      this.model.groupZones = null;
      if (item.zones !== null) {
        this.model.zones = this.zones.filter(function (array) {
          return item.zones.some(function (filter) {
            return filter.id === array.id;
          });
        });
      }
      if (item.zoneGroups !== null) {
        this.model.groupZones = this.groupZones.filter(function (array) {
          return item.zoneGroups.some(function (filter) {
            return filter.id === array.id;
          });
        });
      }
    },
    onChangeStatus: function onChangeStatus(item) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var payload, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.isLoading = true;
                _this5.isUpdate = true;
                _this5.bindModel(item);
                _this5.model.isActive = !!_this5.model.isActive;

                _context5.prev = 4;
                payload = _this5.constructPayload();
                _context5.next = 8;
                return _this5.submitUpdate(payload);

              case 8:
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](4);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context5.prev = 13;

                _this5.isLoading = false;
                return _context5.finish(13);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[4, 10, 13, 16]]);
      }))();
    },
    onEdit: function onEdit(item) {
      this.isUpdate = true;
      this.timestampItem = item.modifiedDate.stringFullDate;
      this.bindModel(item);
    },
    onDelete: function onDelete(item) {
      this.itemIdToBeDeleted = item.id;
      $("#deletemodal").modal();
    },
    onSubmitForm: function onSubmitForm() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var payload, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.isSubmitted = true;
                _this6.$v.model.$touch();

                if (!_this6.$v.model.$error) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt("return");

              case 4:
                _context6.prev = 4;

                _this6.isLoading = true;
                payload = _this6.constructPayload();

                if (!_this6.isUpdate) {
                  _context6.next = 12;
                  break;
                }

                _context6.next = 10;
                return _this6.submitUpdate(payload);

              case 10:
                _context6.next = 14;
                break;

              case 12:
                _context6.next = 14;
                return _this6.submitCreate(payload);

              case 14:
                _context6.next = 19;
                break;

              case 16:
                _context6.prev = 16;
                _context6.t0 = _context6["catch"](4);

                if (_context6.t0.errors) {
                  for (index = 0; index < _context6.t0.errors.length; index++) {
                    _this6.$notification.error(_context6.t0.errors[index], { title: "Error" });
                  }
                }

              case 19:
                _context6.prev = 19;

                _this6.isLoading = false;
                return _context6.finish(19);

              case 22:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[4, 16, 19, 22]]);
      }))();
    },
    constructPayload: function constructPayload() {
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel);

      if (this.isUpdate) {
        payload.id = this.model.id;
        payload.isActive = this.model.isActive;
      }

      payload.masterClassId = this.selectedMasterClass.masterClassId;
      payload.peakPeriodId = this.model.peakPeriodId;
      payload.currency = this.model.currency;
      payload.amountType = this.model.amountType;
      payload.flatRate = this.model.flatRate;
      if (this.model.zones !== null) {
        payload.zones = this.model.zones.map(function (zone) {
          return zone.id;
        });
        payload.zoneIds = this.model.zones.map(function (zone) {
          return zone.id;
        });
      }
      if (this.model.groupZones !== null) {
        payload.groupZones = this.model.groupZones.map(function (zone) {
          return zone.id;
        });
        payload.groupZoneIds = this.model.groupZones.map(function (zone) {
          return zone.id;
        });
      }
      payload.serviceType = this.serviceType;

      return payload;
    },
    submitCreate: function submitCreate(payload) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__services_master_sellingTariff_sellingTariffPeakPeriodSurchargeService_js__["a" /* default */].create(payload);

              case 2:
                _this7.onResetForm();

                _this7.getAll().then(function () {
                  _this7.$notification.success("Successfully created.", {
                    title: "Success"
                  });
                });

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    submitUpdate: function submitUpdate(payload) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__services_master_sellingTariff_sellingTariffPeakPeriodSurchargeService_js__["a" /* default */].update(payload);

              case 2:
                _this8.onResetForm();

                _this8.getAll().then(function () {
                  _this8.$notification.success("Successfully updated.", {
                    title: "Success"
                  });
                });

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    renderRateIntoTable: function renderRateIntoTable(amountType, amount, currency) {
      if (amountType === 1) {
        if (amount) {
          return currency + " " + this.printMoney(amount);
        } else {
          return "-";
        }
      }

      if (amountType === 2) {
        if (amount) {
          return amount + " %";
        } else {
          return "-";
        }
      }
    }
  }
});

/***/ }),

/***/ 782:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_master_sellingTariff_sellingTariffWaitingTimeSurchargeService_js__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_constants__ = __webpack_require__(237);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var defaultModel = {
  id: null,
  masterClassId: null,
  type: null,
  totalMinuteAllowed: null,
  gracePriodInterval: null,
  rate: null,
  currency: null,
  isActive: true,
  zones: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    }
  },
  data: function data() {
    return {
      isSubmitted: false,
      isOpen: false,
      rentalLabel: null,
      allPermissions: [],
      formatter: null,
      moneyFormat: null,
      selectedMasterClass: null,
      timestampItem: null,
      itemIdToBeDeleted: null,
      sourceTypes: __WEBPACK_IMPORTED_MODULE_6__models_constants__["q" /* WaitingTimeType */],
      items: [],
      currencies: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        type: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        totalMinuteAllowed: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) },
        gracePriodInterval: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) },
        currency: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(3) },
        rate: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) },
        zones: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch("setting/getAllPublic");

            case 2:
              publicSettings = _context.sent;

              _this.rentalLabel = _this.$helper.extractSetting(publicSettings, "RentalLabel", "Hourly");

              _this.$eventBus.$on("initializeSellingTariffWaitingTimeSurcharge", _this.initialize);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("initializeSellingTariffWaitingTimeSurcharge");
  },

  methods: {
    initialize: function initialize(masterClass, moneyFormat, formatter, currencies, zones) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var profile, permissions;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.isLoading = true;
                _this2.isOpen = true;
                _this2.selectedMasterClass = masterClass;
                _this2.moneyFormat = moneyFormat;
                _this2.formatter = formatter;
                _this2.currencies = currencies;
                _this2.zones = zones;

                // this.sourceTypes = [
                //   { text: "Airport Transfer (Arrival)", value: "ArrivalAirportTransfer" },
                //   {
                //     text: "Airport Transfer (Departure)",
                //     value: "DepartureAirportTransfer",
                //   },
                //   { text: "In-Town Transfer", value: "InTownTransfer" },
                //   {
                //     text: this.rentalLabel,
                //     value: "Rental",
                //   },
                // ];

                _context2.next = 10;
                return _this2.$store.dispatch("user/getProfile");

              case 10:
                profile = _context2.sent;
                permissions = profile.services["SellingTariffWaitingTimeSurcharge"];

                if (permissions) {
                  _this2.allPermissions = permissions;
                }

                if (_this2.isAllowToRead) {
                  _this2.getAll().then(function () {
                    $(_this2.$refs.vuemodal).modal({
                      backdrop: "static",
                      keyboard: false
                    });
                    _this2.onResetForm();
                  });
                }

              case 14:
                _context2.prev = 14;

                _this2.isLoading = false;
                return _context2.finish(14);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0,, 14, 17]]);
      }))();
    },
    printMoney: function printMoney(value) {
      return this.formatter !== null ? this.formatter.format(value).replace(/[a-z]{3}/i, "").trim() : value;
    },
    onCloseModal: function onCloseModal() {
      this.isOpen = false;
      $(this.$refs.vuemodal).modal("hide");
    },
    onResetForm: function onResetForm() {
      this.isUpdate = false;
      this.timestampItem = null;
      this.clearValidation();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel);
    },
    clearValidation: function clearValidation() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    onEdit: function onEdit(item) {
      this.isUpdate = true;
      this.timestampItem = item.modifiedDate.stringFullDate;
      this.bindModel(item);
    },
    onDelete: function onDelete(item) {
      this.itemIdToBeDeleted = item.id;
      $("#deletemodal").modal();
    },
    bindModel: function bindModel(item) {
      this.model.id = item.id;
      this.model.masterClassId = item.masterClassId;
      this.model.type = item.type;
      this.model.totalMinuteAllowed = item.totalMinuteAllowed;
      this.model.gracePriodInterval = item.gracePriodInterval;
      this.model.rate = item.rate;
      this.model.currency = item.currency;
      this.model.isActive = item.isActive;
      this.model.zones = this.zones.filter(function (array) {
        return item.zones.some(function (filter) {
          return filter.id === array.id;
        });
      });
    },
    constructPayload: function constructPayload() {
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel);

      if (this.isUpdate) {
        payload.id = this.model.id;
        payload.isActive = this.model.isActive;
      }

      payload.masterClassId = this.selectedMasterClass.masterClassId;
      payload.type = this.model.type;
      payload.totalMinuteAllowed = this.model.totalMinuteAllowed;
      payload.gracePriodInterval = this.model.gracePriodInterval;
      payload.rate = this.model.rate;
      payload.currency = this.model.currency;
      payload.zones = this.model.zones.map(function (zone) {
        return zone.id;
      });

      return payload;
    },
    getAll: function getAll() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_sellingTariff_sellingTariffWaitingTimeSurchargeService_js__["a" /* default */].getAll(_this3.selectedMasterClass.masterClassId);

              case 2:
                _this3.items = _context3.sent;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    onChangeStatus: function onChangeStatus(item) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var payload, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.isLoading = true;
                _this4.isUpdate = true;
                _this4.bindModel(item);
                _this4.model.isActive = !!_this4.model.isActive;

                _context4.prev = 4;
                payload = _this4.constructPayload();
                _context4.next = 8;
                return _this4.submitUpdate(payload);

              case 8:
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](4);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context4.prev = 13;

                _this4.isLoading = false;
                return _context4.finish(13);

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[4, 10, 13, 16]]);
      }))();
    },
    onSubmitForm: function onSubmitForm() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var payload, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.isSubmitted = true;
                _this5.$v.model.$touch();

                if (!_this5.$v.model.$error) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                _context5.prev = 4;

                _this5.isLoading = true;
                payload = _this5.constructPayload();

                if (!_this5.isUpdate) {
                  _context5.next = 12;
                  break;
                }

                _context5.next = 10;
                return _this5.submitUpdate(payload);

              case 10:
                _context5.next = 14;
                break;

              case 12:
                _context5.next = 14;
                return _this5.submitCreate(payload);

              case 14:
                _context5.next = 19;
                break;

              case 16:
                _context5.prev = 16;
                _context5.t0 = _context5["catch"](4);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 19:
                _context5.prev = 19;

                _this5.isLoading = false;
                return _context5.finish(19);

              case 22:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[4, 16, 19, 22]]);
      }))();
    },
    submitCreate: function submitCreate(payload) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_sellingTariff_sellingTariffWaitingTimeSurchargeService_js__["a" /* default */].create(payload);

              case 2:
                _this6.onResetForm();

                _this6.getAll().then(function () {
                  _this6.$notification.success("Successfully created.", {
                    title: "Success"
                  });
                });

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    submitUpdate: function submitUpdate(payload) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_sellingTariff_sellingTariffWaitingTimeSurchargeService_js__["a" /* default */].update(payload);

              case 2:
                _this7.onResetForm();

                _this7.getAll().then(function () {
                  _this7.$notification.success("Successfully updated.", {
                    title: "Success"
                  });
                });

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    submitDelete: function submitDelete() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this8.isLoading = true;
                _context8.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_sellingTariff_sellingTariffWaitingTimeSurchargeService_js__["a" /* default */].delete(_this8.itemIdToBeDeleted);

              case 4:
                _this8.itemIdToBeDeleted = null;

                _this8.getAll().then(function () {
                  _this8.$notification.success("Successfully deleted.", {
                    title: "Success"
                  });
                });
                _context8.next = 11;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](0);

                if (_context8.t0.errors) {
                  for (index = 0; index < _context8.t0.errors.length; index++) {
                    _this8.$notification.error(_context8.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context8.prev = 11;

                _this8.isLoading = false;
                setTimeout(function () {
                  $("body").addClass("modal-open");
                }, 500);
                return _context8.finish(11);

              case 15:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[0, 8, 11, 15]]);
      }))();
    },
    cancelDelete: function cancelDelete() {
      setTimeout(function () {
        $("body").addClass("modal-open");
      }, 500);
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.62558b5b2935c5d403af.js